<template>
  <div class="entry">
    <div class="input-form-card">
      <div class="form-item">
        <label class="form-label">联系人</label>
        <el-input
            v-model="form.nickname"
            placeholder="请输入联系人"
        />
      </div>

      <div class="form-item">
        <label class="form-label">电话</label>
        <el-input
            v-model="form.phone"
            placeholder="请输入电话"
            maxlength="11"
        />
      </div>

      <div class="form-item">
        <label class="form-label">首次联系时间</label>
        <el-date-picker
            style="width: 100%;"
            v-model="form.create_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择首次联系时间"
            @change="timeChange"
        />
      </div>

      <div class="form-item">
        <label class="form-label">机构名称</label>
        <el-input
            v-model="form.institution_name"
            placeholder="请输入机构名称"
        />
      </div>

      <div class="form-item">
        <label class="form-label">地址</label>
        <el-input
            v-model="form.address"
            placeholder="请输入地址"
        />
      </div>

      <div class="form-item">
        <label class="form-label">微信</label>
        <el-input
            v-model="form.wechat"
            placeholder="请输入微信"
        />
      </div>

      <div class="form-item">
        <label class="form-label">备注</label>
        <el-input
            v-model="form.remark"
            placeholder="请输入备注"
        />
      </div>

      <div class="form-btn-wrap">
        <button class="submit-btn" @click="submitForm">
          {{ form.id === 0 ? '客户信息录入' : '编辑客户信息录入' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {upload, editApply, applyInfo} from '@/api/api'

  export default {
    name: "Entry",
    data() {
      return {
        form: {
          id: 0,
          nickname: "",
          phone: "",
          address: "",
          institution_name: "",
          wechat: "",
          remark: "",
          create_at: ""
        },
        preview: {
          id_card_img: '',
          live_img: '',
          transfer_img: '',
          user_img: '',
        },
        contractList: [],
        currentUploadType: ""
      };
    },
    mounted() {
      if (this.$route.query.id) {
        this.applyInfo(this.$route.query.id);
      }
    },
    methods: {
      timeChange(value) {
        console.log(value)
      },
      applyInfo(id) {
        applyInfo(id).then(res => {
          const data = res.data;
          Object.keys(this.form).forEach(key => {
            if (data[key] !== undefined) this.form[key] = data[key];
          });
        });
      },

      async submitForm() {
        // 非备注字段必填校验
        if (!this.form.nickname) {
          this.$message.error("请输入联系人");
          return;
        }
        if (!this.form.phone) {
          this.$message.error("请输入电话");
          return;
        }
        // 手机号正则校验 11位大陆手机号
        const phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(this.form.phone)) {
          this.$message.error("请输入正确的11位手机号");
          return;
        }
        if (!this.form.create_at) {
          this.$message.error("请选择首次联系时间");
          return;
        }
        if (!this.form.institution_name) {
          this.$message.error("请输入机构名称");
          return;
        }
        if (!this.form.address) {
          this.$message.error("请输入地址");
          return;
        }
        if (!this.form.wechat) {
          this.$message.error("请输入微信");
          return;
        }

        const submitData = {...this.form};
        await editApply(submitData);
        this.$message.success("提交成功");
        this.$router.push({path: '/entryRecord'});
      }
    }
  };
</script>

<style lang="less" scoped>
  .entry {
    width: 100%;
  }

  .input-form-card {
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    max-width: 680px;
  }

  .form-item {
    margin-bottom: 28px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .form-label {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      text-align: left;
    }
  }

  .upload-box-list {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    .upload-title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 10px;
      text-align: left;
    }

    .upload-box {
      width: 120px;
      height: 120px;
      border: 1px dashed #d1d5db;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      .upload-icon {
        width: 40px;
        height: 40px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .preview-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
      }

      .delete-btn {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 18px;
        height: 18px;
        background: #f53f3f;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .add-box {
      border-style: dashed;
      border-color: #ccc;
    }
  }

  .form-btn-wrap {
    text-align: left;
  }

  .submit-btn {
    padding: 12px 28px;
    background: #4063e8;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background: #3352d1;
    }
  }
</style>
